import React from 'react';
import { Bounce } from "react-reveal";
import Header from "../../Layout/Header";

const Crumb = () => {
    return (
        <div>
        <Header/>
        <div className="profile_crumb">
            <div className="container">
                <div className="row pt-4">
                    <div className={`col-lg-7 ${window.innerWidth > 768 ? "" : "text-center"} pt-4 mt-4`}>
                        <Bounce cascade top>
                            <div className="row mt-5">
                                <div className="col-lg-6 mt-4">
                                    <div className="input-group align-items-center bg-white p-2">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text bg-white border-0 pr-0">
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
                                                        fill="black"
                                                        fillOpacity="0.87"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control border-0 shadow-none"
                                            placeholder="Search by Location"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-4 mb-5">
                                    <div className="input-group bg-white p-2 align-items-center">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text bg-white border-0 pr-0">
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
                                                        fill="black"
                                                        fillOpacity="0.87"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control border-0 shadow-none"
                                            placeholder="Search Doctor by speciality"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Bounce>
                    </div>
                    <div className="hide_on_med col-lg-5 pt-5 mt-5">
                        <h5 style={{ fontSize: `1.2rem` }} className="text-white mt-3 font-weight-bold">Quick search:</h5>
                        <p className="text-white" style={{ fontSize: `0.75rem` }}>Dentist - General Physician - Child Specialist - Dermatologist - Orthopedic Surgeon - Dermatologist</p>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default Crumb;